import { DeleteOutline } from '@mui/icons-material';
import { Grid, IconButton, Paper, Typography } from '@mui/material';
import SpectrumChart from 'features/spectrumChart/SpectrumChart';
import { useEffect, useState, MouseEvent } from 'react';
import { useAppDispatch } from '../../app/hooks';
import { removeAlarmByLogId } from '../spectrasWebSocketServer/spectrasWebSocketServerSlice';
import { useIsSnapshotAlarming } from '../windows/hooks/useIsSnapshotAlarming';
import { LiveAlarmToDisplay } from './types';

interface Props {
  alarmToDisplay: LiveAlarmToDisplay;
  onWindowClick: (analyzerId: number, snapshotId: number) => void;
}
const AlarmLiveTraceDisplay = ({ alarmToDisplay, onWindowClick }: Props) => {
  const dispatch = useAppDispatch();
  const { snapshotIsAlarming } = useIsSnapshotAlarming(
    alarmToDisplay.snapshotId
  );
  const [hideDisplay, setHideDisplay] = useState(false);
  const handleClearAlarm = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(removeAlarmByLogId(alarmToDisplay.alarmLogId));
  };
  useEffect(() => {
    if (!snapshotIsAlarming) {
      const timeout = setTimeout(() => {
        setHideDisplay(true);
      }, 30000);
      return () => clearTimeout(timeout);
    } else {
      setHideDisplay(false);
    }
  }, [snapshotIsAlarming]);
  if (hideDisplay) return null;
  return (
    <Grid
      item
      xs={3}
      component={Paper}
      onClick={() =>
        onWindowClick(alarmToDisplay.analyzerId, alarmToDisplay.snapshotId)
      }
    >
      <Grid
        item
        container
        justifyContent='center'
        style={{ position: 'relative' }}
      >
        <Typography variant='body2'>{alarmToDisplay?.alarmName}</Typography>
        <IconButton
          onClick={handleClearAlarm}
          size='small'
          style={{ position: 'absolute', right: 0 }}
        >
          <DeleteOutline fontSize='small' />
        </IconButton>
      </Grid>
      <SpectrumChart
        analyzerId={alarmToDisplay.analyzerId}
        snapshotId={alarmToDisplay.snapshotId}
      />
    </Grid>
  );
};

export default AlarmLiveTraceDisplay;
